import QueryDetailsStep from '../components/tabs-content/pages/query-details';
import SearchItemsStep from '../components/tabs-content/pages/search-items';
import ConfirmationStep from '../components/tabs-content/pages/confirmation';

const steps = [
    {
        title: 'Query Details',
        stepUniqueKey: 'query-details',
        component: (props) => <QueryDetailsStep {...props} />
    },
    {
        title: 'Confirm Search Items',
        stepUniqueKey: 'search-items',
        component: (props) => <SearchItemsStep {...props} />
    },
    {
        title: ({ t }) => {
            return t('Confirm {{creditLabel}} Usage', {
                creditLabel: 'Credit'
            })
        },
        stepUniqueKey: 'confirmation',
        component: (props) => <ConfirmationStep {...props} />
    }
];

export {
    steps
}